// extracted by mini-css-extract-plugin
module.exports = {"authorizePage":"AuthorizePage_authorizePage__38rYM","alexaLogoContainer":"AuthorizePage_alexaLogoContainer__TFRcD","containerForLinks":"AuthorizePage_containerForLinks__Wv6oI"};